import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';

import { Models } from './index';
import { IArticleItem } from '../components/blog/article-list-item/article-list-item';
import { IEmployeeBoxProps } from '../components/employee-box/employee-box';

export class BlogArticleModel extends ContentItem {
  get id(): string {
    return get(this._config, 'id', '');
  }

  get language(): string {
    return get(this._config, 'system.language', '');
  }

  get slug(): string {
    return get(this._config, 'elements.basic_page_settings__url.value', '');
  }

  get title(): string {
    return get(this._config, 'elements.title_value.value', '');
  }

  get summary(): string {
    return get(this._config, 'elements.summary.value', '');
  }

  get publicationDate(): string {
    return get(this._config, 'elements.publication_date.value', '');
  }

  get image(): {
    url: string;
    description: string;
  } {
    return get(this._config, 'elements.image.value[0]', '');
  }

  get categoryUrl(): string {
    return get(
      this._config,
      'elements.blog_category.value[0].elements.category_url_value.value',
      ''
    );
  }

  get categoryName(): string {
    return get(
      this._config,
      'elements.blog_category.value[0].elements.category_name.value',
      ''
    );
  }

  get author(): IEmployeeBoxProps {
    const authorData = get(this._config, 'elements.author.value[0]', {});
    const modeledData = Models.EmployeeBoxModel.create(
      authorData as IEmployeeBox
    );

    return modeledData;
  }

  get content(): string {
    return get(this._config, 'elements.content', '');
  }

  get featured(): boolean {
    return get(this._config, 'elements.featured.value[0].codename', false);
  }

  get contentHtml(): string {
    return get(this._config, 'elements.content_html.value', '');
  }

  get fullWidthContent(): string {
    return get(this._config, 'elements.full_width_content', '');
  }

  public static create(data: IBlogArticle): IArticleItem {
    const {
      language,
      slug,
      title,
      summary,
      publicationDate,
      image,
      categoryUrl,
      author,
      content,
      id,
      featured,
      contentHtml,
      fullWidthContent,
      categoryName
    } = new BlogArticleModel(data);

    return {
      language,
      id,
      slug,
      title,
      summary,
      publicationDate,
      image,
      categoryUrl,
      author,
      content,
      featured,
      contentHtml,
      fullWidthContent,
      categoryName
    };
  }
}
